import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../authentication/auth.service';

export const authGuardFn: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    authService.logout(); // optionally clear tokens/session

    // Redirect to log in with returnUrl
    router.navigate(['login'], {
      queryParams: { returnUrl: state.url },
    });

    return false;
  }

  return true;
};
